import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
//import { firestore } from 'firebase';
import { map, mergeAll, take } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import "firebase/firestore";
//import * as firebase from 'firebase';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  private _data: BehaviorSubject<any[]>;
  public data: Observable<any[]>;
  latestEntry: any;
  items: Array<any> = []

 constructor(private db: AngularFirestore) { }

   // You need to return the doc to get the current cursor.
  getCollection(ref, queryFn?): Observable<any[]> {
    return this.db.collection(ref, queryFn).snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        const doc = a.payload.doc;
        return { id, ...data, doc };
      }))      
    );  
  }
// In your first query you subscribe to the collection and save the latest entry
 firstAllItems() {
  this._data = new BehaviorSubject([]);
  this.data = this._data.asObservable();

  const scoresRef = this.getCollection('businessCategories', ref => ref
    .where("publish", "==", true)
    .orderBy('name')
    .limit(5))    
    .subscribe(data => {
      this.latestEntry = data[data.length - 1].doc;
      this._data.next(data);
    });
  }

  nextAllItems() {
    const scoresRef = this.getCollection('businessCategories', ref => ref
    .where("publish", "==", true)
      .orderBy('name')
       // Now you can use the latestEntry to query with startAfter
      .startAfter(this.latestEntry)
      .limit(5))
      .subscribe(data => {
        if (data.length) {
          // And save it again for more queries
          this.latestEntry = data[data.length - 1].doc;
          this._data.next(data)
        }
      }
    )
  }
}